function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './FeatureCardsList.css';
import React, { useEffect, useState, useContext, useRef } from 'react';
import throttle from 'lodash/throttle';
import { canUseDOM, get, getColorByTheme, getDictionaryItem, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../atoms/LazyPicture';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import FeatureCardItem from './FeatureCardItem';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
export const FeatureCardsList = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const carousel = params !== undefined && params['Is Carousel'] === '1';
  const isDetSite = get(params, 'RenderingStyle') === 'DDA';
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const carouselWrapperRef = useRef(null);
  const [isVdsite, setIsVdsite] = useState(true);
  const [introHeight, setIntroHeight] = useState(0);
  const [titleHeight, setTitleHeight] = useState(0);
  const [ctaHeight, setCtaHeight] = useState(0);
  const [mobileDevice] = useState(canUseDOM && window.matchMedia(`(max-width: 767px)`).matches);
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (carouselWrapperRef.current) {
        let titleHeight = 0,
          introHeight = 0,
          btnHeight = 0;
        const titlesList = carouselWrapperRef.current.querySelectorAll('.title');
        const introsList = carouselWrapperRef.current.querySelectorAll('.description');
        const ctaBlock = carouselWrapperRef.current.querySelectorAll('.btn-tertiary.btn-tertiary--carousel');
        titlesList.forEach(title => {
          const height = title.offsetHeight;
          if (titleHeight < height) titleHeight = height;
        });
        introsList.forEach(intro => {
          const height = intro.offsetHeight;
          if (introHeight < height) introHeight = height;
        });
        ctaBlock.forEach(btn => {
          const height = btn.offsetHeight;
          if (btnHeight < height) btnHeight = height;
        });
        setTitleHeight(titleHeight);
        setIntroHeight(introHeight);
        setCtaHeight(btnHeight);
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  if (!fields) {
    console.info('FeatureCardsList component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[FeatureCardsList component is empty: please provide data source]");
    }
    return null;
  }
  const items = get(fields, 'data.item.cards.items', []);
  if (items.length < 2) return null;
  const title = get(fields, 'data.item.title.jss.value');
  const hasListdescription = get(fields, 'data.item.description.jss.value');
  const listdescription = get(fields, 'data.item.description.jss');
  const CTATitle = get(fields, 'data.item.cTALinkLabel.jss.value');
  const CTALink = get(fields, 'data.item.cTALink.jss.value.href');
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const dictionaryValues = get(fields, 'data.dictionary');
  const readmore = getDictionaryItem(dictionaryValues, 'ReadMore');
  const itemsToShow = items.length > 2 ? 3 : 2;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const styleThemeHexColor = BackgroundColorHex ? {
    '--m10-profile-cards-background-color': BackgroundColorHex,
    '--m10-profile-cards-background-active-color': ActiveColorHex,
    '--m10-profile-cards-color': ColorHex
  } : {
    '--m10-profile-cards-background-color': selectedPrimaryColor,
    '--m10-profile-cards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m10-profile-cards-color': getColorByTheme(selectedPrimaryColor)
  };
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderTileItems = () => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: `$article-carousel-tile-${index}`
    }, /*#__PURE__*/React.createElement(FeatureCardItem, _extends({}, item, {
      readmore: readmore,
      itemsToShow: itemsToShow,
      mobileDevice: mobileDevice,
      eventsAnalytics: eventsAnalytics,
      params: params,
      isDetSite: isDetSite
    }))));
  };
  const renderTileGridItems = () => {
    return items.map((item, index) => {
      const title = get(item, 'title.jss');
      const description = get(item, 'description.jss');
      const hasDescription = get(item, 'description.jss.value');
      const hasTitle = get(item, 'title.jss.value');
      const image = get(item, 'image.jss.value.src');
      const alt = get(item, 'image.jss.value.alt');
      const CtaHref = get(item, 'cTALink.jss.value.href');
      const CtaTarget = get(item, 'cTALink.jss.value.target');
      const CtaLinktype = get(item, 'cTALink.jss.value.linktype');
      const specificStyles = "sll839h";
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        className: "col-lg-6 grid-item-col",
        animateOnce: true,
        duration: 1 + index / 3,
        key: `$article-carousel-tile-${index}`
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: `grid-item ${!CtaHref && specificStyles}`,
        href: CtaHref,
        linktype: CtaLinktype,
        linksTarget: CtaTarget
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-grid-container",
        onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title.value])
      }, image && /*#__PURE__*/React.createElement(LazyPicture, {
        className: "picture",
        hover: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: `${injectImageResolution(image, 500, 500)}`
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: `${injectImageResolution(image, 750, 750)}`
      }), isDetSite ? /*#__PURE__*/React.createElement("img", {
        src: `${injectImageResolution(image, 775, 210)}`,
        alt: alt
      }) : /*#__PURE__*/React.createElement("img", {
        src: `${injectImageResolution(image, 575, 575)}`,
        alt: alt
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-grid-container",
        onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title.value])
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, hasTitle && /*#__PURE__*/React.createElement(Text, {
        tag: "h2",
        className: "title-grid",
        field: title
      })), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, hasDescription && /*#__PURE__*/React.createElement(Text, {
        tag: "p",
        className: "description-grid",
        field: description
      })), /*#__PURE__*/React.createElement("div", {
        className: "cta-wrapper-grid",
        onClick: e => {
          e.stopPropagation();
          tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), [title.value, readmore]);
        }
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, CtaHref && /*#__PURE__*/React.createElement("div", {
        className: "btn-tertiary btn-tertiary--carousel"
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn-tertiary__text"
      }, readmore), rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null)))))));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    style: styleThemeHexColor
  }, (carousel && mobileDevice || !carousel) && /*#__PURE__*/React.createElement("div", {
    className: carousel ? 'text-wrapper' : 'text-wrapper-list'
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "h3 list__title"
  }, title), hasListdescription && /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "list__short-description",
    field: listdescription
  })), carousel ? /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--intros-height': introHeight,
      '--titles-height': titleHeight,
      '--cta-height': ctaHeight
    }
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: `btn-group--right ${rtl ? 'btn-group-rtl' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "carousel-text-wrapper"
    }, title && /*#__PURE__*/React.createElement("h2", {
      className: "h3 list__title"
    }, title), hasListdescription && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "list__short-description",
      field: listdescription
    })), /*#__PURE__*/React.createElement("div", null, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['sliderAnalytics'], params), ['previous']), true, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['sliderAnalytics'], params), ['next']), true, false, null, isDetSite))), renderCarousel(renderTileItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: itemsToShow
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: itemsToShow
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: CTATitle && CTALink ? 'dot-wrapper' : ''
    }, CTATitle && CTALink && /*#__PURE__*/React.createElement("a", {
      className: `btn ${isDetSite ? "btn-primary" : "btn-secondary"}`,
      href: CTALink,
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['subButtonClickAnalytics'], params), [title, CTATitle]);
      }
    }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaLeftIcon
      },
      className: "ctaLeftIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null), CTATitle, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: ctaRightIcon
      },
      className: "ctaRightIcon"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null)), renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params)), [], isDetSite)));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, renderTileGridItems()), " ", CTATitle && CTALink && /*#__PURE__*/React.createElement("a", {
    className: `btn ${isDetSite ? "btn-primary" : "btn-secondary"} btn-list`,
    href: CTALink,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['subButtonClickAnalytics'], params), [title, CTATitle]);
    }
  }, ctaLeftIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaLeftIcon
    },
    className: "ctaLeftIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), CTATitle, ctaRightIcon ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: ctaRightIcon
    },
    className: "ctaRightIcon"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null)), " ")));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isDetSite
  } = _ref3;
  const commonStyles = isDetSite ? "c1hzp8u0" : "cxs1oo7";
  const ltrStyles = isDetSite ? "l1gayztv" : "l8zwb2z";
  const rtlStyles = isDetSite ? "r1w750im" : "r1986o2v";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default FeatureCardsList;